import React from 'react';
import { Helmet } from 'react-helmet';
import { Query } from 'react-apollo';
import { GET_SCHOOLS } from 'graphql/student_college';
import Loading from 'components/common/Spin';
import Applications from './Applications';
import { Box } from '@material-ui/core';
import { Route, Switch } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import College from './Applications/College';

const Tracker = ({ student, match }) => {
  const queryParams = { student_sub: student.sub };

  const { path } = match;

  return (
    <>
      <Helmet title="Application Tracker" />
      <Query query={GET_SCHOOLS} variables={queryParams}>
        {({ data, loading }) => {
          if (loading || !data) return <Loading spinning />;

          const { student_college: applications } = data;

          return (
            <Box marginBottom={15}>
              <Applications student={student} applications={applications} />
              <Route
                path={`${path}/:id`}
                render={(props) => (
                  <Drawer anchor="right" open onClose={() => props.history.goBack()}>
                    <College
                      school={applications.find(i => i.college_id === props.match.params.id)}
                      onClose={() => props.history.goBack()}
                      collegeId={props.match.params.id}
                      {...props}
                    />
                  </Drawer>
                )}
              />
            </Box>
          );
        }}
      </Query>
    </>
  );
};

export default Tracker;
